import { render, staticRenderFns } from "./shegong.vue?vue&type=template&id=39f1c4b2&scoped=true&"
import script from "./shegong.vue?vue&type=script&lang=js&"
export * from "./shegong.vue?vue&type=script&lang=js&"
import style0 from "./shegong.vue?vue&type=style&index=0&id=39f1c4b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f1c4b2",
  null
  
)

export default component.exports